import { RequestService } from '../../../../common/services/RequestService';
import { GET_VEHICLE } from '../constants';
import { dataAdjustmentCardResponse } from './dataAdjustment';

export const getVehicleByIdRequest = async (profileId, vehicleId) => {
  const response = await RequestService.get(
    GET_VEHICLE.replace('{profile_id}', profileId).replace('{id}', vehicleId)
  );
  return dataAdjustmentCardResponse(response.data);
};
